import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { AllStockTakeLotFieldsFragmentDoc } from '../../../../_lib/__generated__/stock-take-lots-fragment.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StockTakeReviewQueryVariables = Types.Exact<{
  stockTakeId: Types.Scalars['ID'];
  facilityId: Types.Scalars['ID'];
  input?: Types.InputMaybe<Types.StockTakeLotsInput>;
  options?: Types.InputMaybe<Types.StockTakeLotsOptions>;
}>;


export type StockTakeReviewQuery = { readonly __typename?: 'Query', readonly stockTake?: { readonly __typename?: 'StockTake', readonly locationId: string, readonly lots: { readonly __typename?: 'StockTakeLotsPage', readonly items: ReadonlyArray<{ readonly __typename?: 'StockTakeLotAddition', readonly id: string, readonly name: string, readonly expiryDate: string, readonly lastStockTakeAt?: string | null, readonly additionReviewQuantity: number, readonly additionQuantityDifference: number, readonly additionLot?: { readonly __typename?: 'StockTakePartialLot', readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> } } | null } | { readonly __typename?: 'StockTakeLotUpdate', readonly id: string, readonly name: string, readonly reviewedQuantity?: number | null, readonly initialQuantity: number, readonly quantityDifference: number, readonly lastStockTakeAt?: string | null, readonly lot: { readonly __typename?: 'StockTakePartialLot', readonly expiryDate: string, readonly sku: { readonly __typename?: 'Sku', readonly id: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly origin: string }> } } }> }, readonly aggregateInfo: { readonly __typename?: 'StockTakeAggregateInfo', readonly totalLotCount: number, readonly reviewedLotCount: number, readonly totalNewLotsAdded: number, readonly totalQuantityAdded: number, readonly totalQuantityRemoved: number } } | null };

export type FinaliseStockTakeMutationVariables = Types.Exact<{
  input: Types.FinaliseStockTakeInput;
}>;


export type FinaliseStockTakeMutation = { readonly __typename?: 'Mutation', readonly finaliseStockTake: { readonly __typename?: 'StockTake', readonly id: string, readonly aggregateInfo: { readonly __typename?: 'StockTakeAggregateInfo', readonly totalLotCount: number, readonly reviewedLotCount: number, readonly totalNewLotsAdded: number, readonly totalQuantityAdded: number, readonly totalQuantityRemoved: number } } };


export const StockTakeReviewDocument = gql`
    query stockTakeReview($stockTakeId: ID!, $facilityId: ID!, $input: StockTakeLotsInput, $options: StockTakeLotsOptions) {
  stockTake(input: {stockTakeId: $stockTakeId, facilityId: $facilityId}) {
    locationId
    lots(input: $input, options: $options) {
      items {
        ...AllStockTakeLotFields
      }
    }
    aggregateInfo {
      totalLotCount
      reviewedLotCount
      totalNewLotsAdded
      totalQuantityAdded
      totalQuantityRemoved
    }
  }
}
    ${AllStockTakeLotFieldsFragmentDoc}`;

/**
 * __useStockTakeReviewQuery__
 *
 * To run a query within a React component, call `useStockTakeReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useStockTakeReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStockTakeReviewQuery({
 *   variables: {
 *      stockTakeId: // value for 'stockTakeId'
 *      facilityId: // value for 'facilityId'
 *      input: // value for 'input'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useStockTakeReviewQuery(baseOptions: Apollo.QueryHookOptions<StockTakeReviewQuery, StockTakeReviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StockTakeReviewQuery, StockTakeReviewQueryVariables>(StockTakeReviewDocument, options);
      }
export function useStockTakeReviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StockTakeReviewQuery, StockTakeReviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StockTakeReviewQuery, StockTakeReviewQueryVariables>(StockTakeReviewDocument, options);
        }
export type StockTakeReviewQueryHookResult = ReturnType<typeof useStockTakeReviewQuery>;
export type StockTakeReviewLazyQueryHookResult = ReturnType<typeof useStockTakeReviewLazyQuery>;
export type StockTakeReviewQueryResult = Apollo.QueryResult<StockTakeReviewQuery, StockTakeReviewQueryVariables>;
export const FinaliseStockTakeDocument = gql`
    mutation finaliseStockTake($input: FinaliseStockTakeInput!) {
  finaliseStockTake(input: $input) {
    id
    aggregateInfo {
      totalLotCount
      reviewedLotCount
      totalNewLotsAdded
      totalQuantityAdded
      totalQuantityRemoved
    }
  }
}
    `;
export type FinaliseStockTakeMutationFn = Apollo.MutationFunction<FinaliseStockTakeMutation, FinaliseStockTakeMutationVariables>;

/**
 * __useFinaliseStockTakeMutation__
 *
 * To run a mutation, you first call `useFinaliseStockTakeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinaliseStockTakeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finaliseStockTakeMutation, { data, loading, error }] = useFinaliseStockTakeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFinaliseStockTakeMutation(baseOptions?: Apollo.MutationHookOptions<FinaliseStockTakeMutation, FinaliseStockTakeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinaliseStockTakeMutation, FinaliseStockTakeMutationVariables>(FinaliseStockTakeDocument, options);
      }
export type FinaliseStockTakeMutationHookResult = ReturnType<typeof useFinaliseStockTakeMutation>;
export type FinaliseStockTakeMutationResult = Apollo.MutationResult<FinaliseStockTakeMutation>;
export type FinaliseStockTakeMutationOptions = Apollo.BaseMutationOptions<FinaliseStockTakeMutation, FinaliseStockTakeMutationVariables>;